export const ACTIVE_ROUTER_TAB_FEATURE_KEY = 'active-router-tab';

export interface ActiveRouterTabState {
  [parentRouteName: string]: string | undefined;
}
